export const routes = {
  getRootPage () {
    return '/'
  },
  getProfilePage (tokenId?: string) {
    if (tokenId) return `/profile/token/${tokenId}`
    return '/profile/project'
  },
  getContentPage (category?: string) {
    if (!category) return '/content'
    return `/content/${category.toLowerCase()}`
  },
  getContentDetailPage (contentId: string, contentType: string) {
    return `/content/${contentType.toLowerCase()}/${contentId}`
  },
  getEcosystemPage () {
    return '/ecosystem'
  },
  getEcosystemProjectPage (projectId: string) {
    return `/ecosystem/${projectId}`
  },
  getDefiDashboardListPage () {
    return '/defi-dashboard'
  },
  getFeaturedPage (projectId: string, featuredId: string) {
    return `/ecosystem/${projectId}/featured/${featuredId}`
  },
  getAnalyticsPage () {
    return '/on-chain/analytics'
  },
  getCirculatingSupplyPage () {
    return '/circulating-supply'
  },
  getTermsPage () {
    return '/terms-of-service'
  }
}

export const explorerRoutes = {
  getRootPage () {
    return import.meta.env.VITE_APP_EXPLORER_URL
  },
  getBlockDetailPage (blockHeight: string) {
    return `${this.getRootPage()}/blocks/${blockHeight}/block`
  },
  getTransactionDetailPage (version: string) {
    return `${this.getRootPage()}/transactions/${version}/transaction`
  },
  getAccountDetailPage (address: string) {
    return `${this.getRootPage()}/accounts/${address}/transactions`
  },
  getModulePage (address: string, moduleName: string) {
    return `${this.getRootPage()}/accounts/${address}/modules#${moduleName}`
  },
}